import { Route, Routes } from 'react-router-dom';

import { Customers } from './khach-hang';
import { Products } from './san-pham';
import { OrganizationRoles } from './vai-tro';

export const Categories = () => {
  return (
    <Routes>
      <Route path="khach-hang" element={<Customers />} />
      <Route path="san-pham" element={<Products />} />
      <Route path="vai-tro" element={<OrganizationRoles />} />
    </Routes>
  );
}